import type { ISubCategory } from "../../entities/category.entity";

const findPathById = (
	list: ISubCategory[] | undefined,
	targetId: string,
	path: string[] = [],
): string[] | null => {
	if (!list) return null;

	for (const node of list) {
		const nextPath = [...path, node.id!];
		if (node.id === targetId) {
			return nextPath;
		}

		const nested = findPathById(node.subCategories, targetId, nextPath);
		if (nested) return nested;
	}

	return null;
};

const normalizePathIds = (
	list: ISubCategory[] | undefined,
	pathIds: string[],
) => {
	const normalized: string[] = [];
	let current = list;

	for (const id of pathIds) {
		const found = current?.find((item) => item.id === id);
		if (!found) return null;
		normalized.push(found.id!);
		current = found.subCategories;
	}

	return normalized;
};

export const resolveSubCategoryPathIds = (
	list: ISubCategory[] | undefined,
	pathIds: string[],
) => {
	if (pathIds.length === 0) {
		return { ids: [] as string[], isValid: true };
	}

	const normalized = normalizePathIds(list, pathIds);
	if (normalized) {
		const isSamePath = normalized.join("/") === pathIds.join("/");
		return { ids: normalized, isValid: isSamePath };
	}

	const fallbackId = pathIds[pathIds.length - 1];
	const resolved = list ? findPathById(list, fallbackId) : null;

	if (resolved) {
		return { ids: resolved, isValid: false };
	}

	return { ids: [] as string[], isValid: false };
};
